<script lang="ts" setup>
  import type { TypeTypeformComponent } from '~/types/contentful'

  defineProps<{
    data: TypeTypeformComponent<'WITHOUT_UNRESOLVABLE_LINKS', string>
  }>()
</script>

<template>
  <section class="m-typeform module-paddings">
    <CTypeform
      :background-color="data.fields.base?.fields.backgroundColour"
      :typeform-id="data.fields.typeformId"
      class="m-typeform__typeform"
    />
  </section>
</template>

<style lang="scss" scoped>
  .m-typeform {
    background-color: v-bind('data.fields.base?.fields.backgroundColour');

    .m-typeform__typeform {
      margin: 0 auto;

      width: min(100%, 960px);
    }
  }
</style>
